import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map'
import 'rxjs/Rx';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { CommonService } from '../providers/common';

@Injectable()
export class ServicesProvider {
  // private API_URL = "https://gateway.alpha.theonemoment.net/"; // Alpha
  //  private API_URL = "http://localhost:8000/"; //localhost
  private API_URL = "https://gateway.theonemoment.net/"; // UAT
  //  private API_URL = "https://gateway.stage.theonemoment.co/"; // Staging



   

  formjs: any;

  static get parameters() {
    return [[Http]];
  }

  constructor(public http: Http, public router: Router) {
    console.log('Hello ServicesProvider Provider');
    this.importCall();
  }

  async importCall() {
    this.formjs = await import('./route.js');
    this.router = this.formjs.returnPath();
    this.router = this.router[0];
  }

  postRequest(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "Patient/" + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    })
  }
  postRequestdocs(apiname): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "patient/" + apiname;
      var response = this.http.post(url, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    })
  }

  postRequestDoc(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "doctor/" + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }
  postRequestPhysioDoc(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "physiotherapy/" + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }
  postRequest2(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "admin/" + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }

  postRequest1(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "trainer/" + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }

  getRequest(apivalue): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "Patient/" + apivalue;
      var response = this.http.get(url, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.get(url, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }

  MultipartDataUPload(apivalue, receivedStandardInfo): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "Patient/" + apivalue;
      var response = this.http.post(url, receivedStandardInfo, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, receivedStandardInfo, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }

  imageUpload(url, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      var url1 = this.API_URL + "upload/" + url;
      var response = this.http.post(url1, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url1, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }
  imageUploadS3Bucket(url, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      var url1 = this.API_URL + url;
      var response = this.http.post(url1, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url1, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }
  imageUploadServer(url, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      var url1 = "https://uploadtestapi.theonemoment.com/" + url;
      var response = this.http.post(url1, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url1, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }

  pharmacyRequest(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "pharmacy/" + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }

  postRequestGndrl(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }

  paymentpostRequest(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "admin/" + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }

  ClinicData(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "clinic/" + apiname;
      var response = this.http.post(url, requestdata, options).timeout(60000).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).timeout(60000).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }


  dietRequest(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "Diet/" + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }

  dietGetRequest(apivalue,body): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "Diet/" + apivalue;
      var response = this.http.post(url,body, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.get(url, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    });
  }
  postRequestNurse(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "Nurse/" + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    })
  }
  postRequestRoom(apiname, requestdata): Observable<any> {
    this.importCall();
    return new Observable(observer => {
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
      let options = new RequestOptions({ headers: headers });
      let url = this.API_URL + "BookRoom/" + apiname;
      var response = this.http.post(url, requestdata, options).map(res => res.json());
      response.subscribe(async (res: any) => {
        if (res.error != undefined && res.error.message == "jwt expired") {

          let reqDataToken = {
            "refreshtoken": localStorage.getItem("refreshtoken")
          }
          let tokenResponse = await this.http.post(this.API_URL + 'tokenGenerate', reqDataToken).map((res) => res.json());

          tokenResponse.subscribe((res: any) => {
            if (res.msg == "Authentication failed") {
              this.router.navigateByUrl("/login");
            } else {
              localStorage.setItem("tokenHeader", res.token);
              var headersControl = new Headers();
              headersControl.append('Content-Type', 'application/json');
              headersControl.append('authorization', 'Bearer ' + localStorage.getItem("tokenHeader"));
              let optionsControl = new RequestOptions({ headers: headersControl });
              let responseCheck = this.http.post(url, requestdata, optionsControl).map(res => res.json());
              responseCheck.subscribe((res1: any) => {
                observer.next(res1);
              })
            }
          });
        } else {
          // response.subscribe(async (resResolved: any) => {
          observer.next(res);
          // });
        }
      });
    })
  }

  async aws_upload(formData) {
    try {
      const uploadUrl = 'admin/awsS3FileUploadpdfview';
      const response = await this.http.post(this.API_URL + uploadUrl, formData, {

      });
      return response;
    } catch (error) {
      if (!error.response) {
        console.error('Error connecting to Database');
      } else {
        console.error('Error:', error.response.data || error.message);
      }
    }
  }


  apiURL() {
    return this.API_URL;
  }
}
